import image_1 from "./image_1x2.png";
import image_2 from "./image_2x2.png";
import image_3 from "./image_3x2.png";
import image_4 from "./image_4x2.png";
import image_5 from "./image_5x2.png";
import image_6 from "./image_6x2.png";

import image_man from "./image_manx2.png";

import image_1_hover from "./image_1_hover.png";
import image_2_hover from "./image_2_hover.png";
import image_3_hover from "./image_3_hover.png";
import image_4_hover from "./image_4_hover.png";
import image_5_hover from "./image_5_hover.png";
import image_6_hover from "./image_6_hover.png";

const images = [
  { url: image_1, id: "img_1" },
  { url: image_2, id: "img_2" },
  { url: image_3, id: "img_3" },
  { url: image_4, id: "img_4" },
  { url: image_5, id: "img_5" },
  { url: image_6, id: "img_6" }
];

const images_hover = [
  { url: image_1_hover, id: "img_1_hover" },
  { url: image_2_hover, id: "img_2_hover" },
  { url: image_3_hover, id: "img_3_hover" },
  { url: image_4_hover, id: "img_4_hover" },
  { url: image_5_hover, id: "img_5_hover" },
  { url: image_6_hover, id: "img_6_hover" }
];

const man = {
  url: image_man,
  id: "img_man"
};

export { images, man , images_hover};
